import React from 'react';
import { Mutation } from '@apollo/client/react/components';
import PubSub from 'pubsub-js';
import { IMPORT_URLS } from '../../../queries/titleContent';
import ImportUrlsForm from '../components/importUrlsForm';

const ImportUrls: React.FC = () => {
  return (
    <Mutation
      mutation={IMPORT_URLS}
      update={async () => {
        PubSub.publish('CLOSE-DRAWER');
      }}
    >
      {(importPostsFromWordpress: any) => <ImportUrlsForm query_f={importPostsFromWordpress} />}
    </Mutation>
  );
};

export default ImportUrls;
